<template>
  <div>
    <table
      v-intersect.once
      class="youtube-list__table">
      <thead class="youtube-list__thead">
        <tr>
          <th class="youtube-list__cell-thumbnail"></th>
          <th class="youtube-list__cell-channel">動画情報 / チャンネル名</th>
          <th class="youtube-list__cell-date">公開日</th>
          <th class="youtube-list__cell-views">視聴回数</th>
        </tr>
      </thead>
      <tbody
        v-if="video"
        class="youtube-list__tbody">
        <tr
          @click.prevent="onRowClicked(video.videoId)">
          <td>
            <img
              v-if="video.thumbnailUrl"
              :src="video.thumbnailUrl"
              alt="">
          </td>
          <td>
            <div
              style="text-align: left;font-weight: bold">
              {{ video.title }}
            </div>
            <div style="font-size: 12px;margin-top: 12px;">
              <div style="display: flex">
                <div class="youtube-detail-label">チャンネル名</div>
                <div
                  class="youtube-detail-value">
                  {{ video.channelTitle }}
                </div>
              </div>
              <div style="display: flex">
                <div class="youtube-detail-label">登録者数</div>
                <div class="youtube-detail-value description">
                  <template v-if="video.channel">
                    {{ video.channel.subscriberCount | number }}人 <br />
                    {{ video.channel.videoCount }}本の動画
                  </template>
                  <template v-else>
                    --
                  </template>
                </div>
              </div>
              <div style="display: flex">
                <div class="youtube-detail-label">所有者</div>
                <div class="youtube-detail-value description">
                  <span v-if="video.channel && video.channel.contentOwner">
                    {{ video.channel.contentOwner }}
                  </span>
                  <span v-else>--</span>
                </div>
              </div>
            </div>
          </td>
          <td>{{ moment(video.timeCreated).format('YYYY/MM/DD') }}</td>
          <td>
            {{ video.statistics ? video.statistics.viewCount : 0 | number }} 回
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import moment from 'moment/moment'

export default {
  name: 'YouTubeClaimsClaimTable',
  props: {
    video: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  computed: {
    moment() {
      return moment
    },
  },
  methods: {
    onRowClicked(id) {
      this.$emit('row-clicked', id)
    },
    request() {
      this.$emit('request')
    },
  },
}
</script>

<style scoped>
.youtube-detail-label {
  width: 80px;
  color: grey;
  font-size: 12px;
  text-align: left;
}
.youtube-detail-value {
  font-size: 12px;
  width: 300px;
  text-align: left;
}
.youtube-list__cell-channel {
  width: 300px;
}
.youtube-list__cell-views {
  width: 80px;
}
</style>
